// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import React, { ReactElement } from 'react';

import './IconCount.scss';

type IconCountProps = { count: number; children: ReactElement | string; className?: string };

const IconCount = ({ count, children, className }: IconCountProps): ReactElement => {
    return (
        <span
            data-count={count < 0 ? `+${Math.abs(count)}` : count}
            className={classList('icon-count', 'ant-menu-item-icon', className)}
        >
            {children}
        </span>
    );
};

export default IconCount;
